import { registerValidator, Validation } from '@philips-emr/tws-core/lib/services/model-service';
import { isEmptyObject, isUndefined } from '@philips-emr/tws-utils';

const isDefined = (value: any): boolean => (
  !isUndefined(value) && value !== null && value !== '' && !isEmptyObject(value)
);

export const REQUIRED = 'required';

function RequiredValidator(value: any): Validation[] {
  const valid = Array.isArray(value) ? Boolean(value.length) : isDefined(value);

  return [{
    message: valid ? '' : 'tws.validator.required',
    name: REQUIRED,
    valid,
  }];
}

export default registerValidator(REQUIRED, RequiredValidator);
